module.exports = __webpack_public_path__ + "static/img/hx4.f6a6181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx4.png
// module id = 39EP
// module chunks = 1